const QUICK_PROMPTS = [
  "What can I do on the dashboard?",
  "How do location filters work?",
  "Where are quarterly trends?",
  "How do I export data?",
];

const normalizeText = (text = "") =>
  String(text)
    .toLowerCase()
    .normalize("NFKC")
    .replace(/[^\p{L}\p{N}\s]/gu, " ")
    .replace(/\s+/g, " ")
    .trim();

const QUICK_ANSWERS = {
  "what can i do on the dashboard":
    "The Dashboard shows taste trend charts, category breakdowns, and popular cuisines or beverages for your selected country and locations. Use the quarter and location filters at the top, then explore the sunburst chart and tabbed product sections below.",

  "how do location filters work":
    "Use the filters at the top of the Dashboard or Quarterly Trend pages to choose country, location levels, year/quarter, and ratings. Changing filters refreshes the charts and tables for that selection. Your last dashboard quarter filter is remembered in the session when you return.",

  "where are quarterly trends":
    "Open Quarterly Trend from the left menu to compare cuisines, dishes, and beverages over time. You can filter by location and year, view bar charts, and inspect top flavours in the tables.",

  "how do i export data":
    "Where export is available on list or detail views, use the download control on that page to export the current table data, often as Excel. Apply your filters first so the export matches what you see on screen.",
};

const QUICK_ANSWER_ALIASES = {
  "what can i do on the dashboard":
    "what can i do on the dashboard",

  "what can i see on the dashboard":
    "what can i do on the dashboard",

  "explain the dashboard":
    "what can i do on the dashboard",

  "how do location filters work":
    "how do location filters work",

  "how do i use location filters":
    "how do location filters work",

  "where are quarterly trends":
    "where are quarterly trends",

  "how do i find quarterly trends":
    "where are quarterly trends",

  "how do i export data":
    "how do i export data",

  "how can i download data":
    "how do i export data",
};

const getLocalResponse = (rawMessage) => {
  const message = normalizeText(rawMessage);

  if (!message) {
    return null;
  }

  // Direct match
  const directMatch = QUICK_ANSWERS[message];

  if (directMatch) {
    return directMatch;
  }

  // Explicit alias match
  const canonicalQuestion = QUICK_ANSWER_ALIASES[message];

  if (canonicalQuestion) {
    return QUICK_ANSWERS[canonicalQuestion] ?? null;
  }

  // Not a predefined question: use RAG
  return null;
};

export {
  QUICK_PROMPTS,
  QUICK_ANSWERS,
  getLocalResponse,
  normalizeText,
};
